<script setup lang="ts">
const year = new Date().getFullYear();
</script>

<template>
  <footer class="footer">
    <div class="os1-shell footer__shell">
      <div class="footer__col">
        <div class="footer__brand">OS1</div>
        <p>
          A small, quiet clothing house. Companion software included. Made for the
          person on the other end of the line.
        </p>
      </div>
      <div class="footer__col">
        <span class="footer__head">Catalog</span>
        <a href="#shop">All pieces</a>
        <a href="#shop">Volume 01 — Warm Red</a>
        <a href="#shop">Lookbook</a>
      </div>
      <div class="footer__col">
        <span class="footer__head">Companion</span>
        <a href="#install">OS1 Desktop</a>
        <a href="#install">OS1 Mobile</a>
        <a href="#">Performance log</a>
      </div>
      <div class="footer__col">
        <span class="footer__head">House</span>
        <a href="#">About</a>
        <a href="#">Returns</a>
        <a href="#">Contact</a>
      </div>
    </div>
    <div class="footer__bar os1-shell">
      <span>© OS1 {{ year }}</span>
      <span>Originally a codename: janioquadros</span>
      <span>Her-inspired. Not affiliated with the film, Warner Bros., or any cast/rights holder.</span>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  border-top: 1px solid var(--os1-line);
  padding-block: 3rem 1.6rem;
  background: linear-gradient(180deg, #0e0303 0%, #050101 100%);
}

.footer__shell {
  display: grid;
  grid-template-columns: 1.4fr repeat(3, 1fr);
  gap: 2rem;
}

.footer__brand {
  font-family: var(--os1-font-serif);
  font-size: 1.8rem;
  letter-spacing: 0.18em;
  color: var(--os1-paper);
}

.footer__col p {
  color: var(--os1-ink-mute);
  margin-top: 0.5rem;
  max-width: 38ch;
  font-size: 0.85rem;
}

.footer__col {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.footer__head {
  font-size: 0.62rem;
  letter-spacing: 0.32em;
  text-transform: uppercase;
  color: var(--os1-ink-mute);
  margin-bottom: 0.2rem;
}

.footer__col a {
  color: var(--os1-ink-soft);
  font-size: 0.85rem;
}

.footer__col a:hover {
  color: var(--os1-rose);
}

.footer__bar {
  display: flex;
  flex-wrap: wrap;
  gap: 1.2rem;
  margin-top: 2.5rem;
  padding-top: 1.2rem;
  border-top: 1px solid var(--os1-line);
  font-size: 0.7rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--os1-ink-mute);
}

@media (max-width: 820px) {
  .footer__shell {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
